import { ref } from "vue";

export type AlertStatus = 'success' | 'error' | 'conflict';

export type Alert = {
    status: AlertStatus;
    summary?: string;
    detail?: string;
};

export function useAlert() {
    const alert = ref<Alert | null>(null);

    return alert;
}